import React from 'react';

interface CategoryTextComponentProps {
  title?: string;
  text?: string;
}

export const CategoryTextComponent: React.FC<CategoryTextComponentProps> = ({ title, text }) => {
  if (!title && !text) {
    return null;
  }

  return (
    <div className="category-text-container py-4 bg-white rounded-lg mb-4">
      {title && (
        <h2 className="text-xl font-bold mb-2">{title}</h2>
      )}

      {text && (
        <div className="text-gray-700" dangerouslySetInnerHTML={{ __html: text }} />
      )}
    </div>
  );
};